/**
 * wmList.ts — 담당 WM 여러 명(공동관리 · 2026-10-26 지도사 「한 업체에 WM 여러 명 등록 가능하게 · 공동관리하는 개념이 있어」)
 *   업체 · 상담이 옛 모양(wm_id 하나)으로 와도 같은 목록으로 읽는다 — 첫 분이 대표
 */
import type { Company, Consultation, WM } from './types';

/** 업체 담당 WM id(대표 먼저) */
export function companyWmIds(c: Pick<Company, 'wm_id' | 'wms'> | null | undefined): string[] {
  if (!c) return [];
  const list = (c.wms || []).map((w) => w.wm_id).filter(Boolean);
  if (list.length) return Array.from(new Set(list));
  return c.wm_id ? [c.wm_id] : [];
}

/** 상담에 함께한 WM id(첫 분 = wm_id) */
export function consultWmIds(c: Pick<Consultation, 'wm_id' | 'wm_ids'> | null | undefined): string[] {
  if (!c) return [];
  const list = Array.isArray(c.wm_ids) ? c.wm_ids.filter(Boolean) : [];
  if (list.length) return Array.from(new Set(list));
  return c.wm_id ? [c.wm_id] : [];
}

/** WM 이름 줄 — 「김상균, 박지영」 · 없으면 빈 글 */
export function wmNames(ids: string[], wms: Pick<WM, 'id' | 'name'>[], fallback: string[] = []): string {
  const byId = new Map(wms.map((w) => [w.id, w.name]));
  const names = ids.map((id, i) => byId.get(id) || fallback[i] || '').filter(Boolean);
  return names.join(', ');
}
